module.exports = __webpack_public_path__ + "img/star-bold.dd942a7e.svg";